import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { Icon } from './SvgIcons';
import { getAdminUrl, isAdminHost } from '../utils/tenant';

function decodeJwt(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const padded = payload.padEnd(payload.length + (4 - (payload.length % 4)) % 4, '=');
    const decoded = Buffer.from(padded, 'base64').toString('utf8');
    return JSON.parse(decoded);
  } catch (e) {
    return null;
  }
}

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const authPages = ['/login'];
  if (authPages.includes(location.pathname)) return null;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isImpersonating = localStorage.getItem('is_impersonating') === 'true';

  const isAdminSubdomain = isAdminHost();

  const handleReturnToAdmin = () => {
    const backupToken = localStorage.getItem('admin_access_token_backup');
    if (backupToken) {
      localStorage.setItem('token', backupToken);
      const payload = decodeJwt(backupToken);
      if (payload) {
        localStorage.setItem('user', JSON.stringify({
          user_id: payload.user_id,
          name: payload.name,
          email: payload.email,
          role: payload.role,
          college_id: payload.college_id,
          university_id: payload.university_id,
          department_id: payload.department_id,
          subject_id: payload.subject_id,
          department: payload.department
        }));
      }
    }
    localStorage.removeItem('is_impersonating');
    localStorage.removeItem('admin_access_token_backup');
    localStorage.removeItem('admin_user_backup');
    localStorage.removeItem('impersonation_target');
    window.location.href = getAdminUrl();
  };

  return (
    <>
      {isImpersonating && (
        <div style={{
          backgroundColor: '#fef3c7',
          borderBottom: '1px solid #f59e0b',
          padding: '0.5rem 1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          fontSize: '0.875rem',
          color: '#92400e'
        }}>
          <span style={{ fontWeight: 600 }}>Impersonating</span>
          <span>{user?.name || 'a user'} ({user?.email || ''})</span>
          <button
            onClick={handleReturnToAdmin}
            style={{
              padding: '0.3rem 0.75rem',
              borderRadius: '0.375rem',
              border: '1px solid #d97706',
              backgroundColor: '#fbbf24',
              color: '#78350f',
              fontWeight: 600,
              fontSize: '0.8rem',
              cursor: 'pointer'
            }}
          >
            Return to Super Admin
          </button>
        </div>
      )}
      <nav className={`navbar ${user ? 'with-sidebar' : ''}`}>
        <div className="navbar-brand">
          {user ? (
            <span>Welcome, {user.name}</span>
          ) : (
            <Link to="/" style={{ color: 'var(--text-primary)', textDecoration: 'none', fontWeight: 700 }}>Unified QPG</Link>
          )}
        </div>

        <div className="navbar-menu">
          {user ? (
            <button onClick={handleLogout} className="btn btn-secondary btn-sm" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
              <Icon name="LogOut" size={16} />
              <span>Logout</span>
            </button>
          ) : (
            <>
              <Link to="/login" className="btn btn-primary btn-sm navbar-link">Login</Link>
              
            </>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
